import React from 'react';
import { useParams } from 'react-router-dom';

import { useFacilityCurrent } from '../../hooks/useFacilityCurrent';
import { useFacilityDaily } from '../../hooks/useFacilityDaily';
import { useFacilityMembers } from '../../hooks/useFacilityMembers';

import RoleGuard from './RoleGuard';
import FacilityNameEditor from './FacilityNameEditor';
import DashboardHeroCards from './DashboardHeroCards';
import OpenStatusFunnel from './OpenStatusFunnel';
import RecommendationFunnel from './RecommendationFunnel';
import RiskScoreBreakdown from './RiskScoreBreakdown';
import CoordinatorTable from './CoordinatorTable';
import VolumeTrendChart from './VolumeTrendChart';
import PayerMix from './PayerMix';
import SourceMix from './SourceMix';
import FacilityClosedOutcomeBreakdown from './FacilityClosedOutcomeBreakdown';
import FlagFiringRate from './FlagFiringRate';
import SeverityBreakdown from './SeverityBreakdown';

import '../../styles/FacilityDashboard.css';

export default function FacilityDashboard() {
    const { facilityId } = useParams();
    const { data: currentState, loading: loadingCurrent } = useFacilityCurrent(facilityId);
    const { docs: dailyDocs, loading: loadingDaily } = useFacilityDaily(facilityId, 30);
    const { members } = useFacilityMembers(facilityId);

    return (
        <RoleGuard requireFacilityAdmin facilityId={facilityId}>
            <div className="facility-dashboard">
                <div className="dashboard-header">
                    <h1>Facility Overview</h1>
                    <FacilityNameEditor facilityId={facilityId} />
                </div>
                {(loadingCurrent || loadingDaily) && (
                    <div className="dashboard-loading">Loading…</div>
                )}
                <DashboardHeroCards currentState={currentState} dailyDocs={dailyDocs} />
                <OpenStatusFunnel openByStatus={currentState?.open_by_admission_status} />
                <div className="dashboard-two-col">
                    <RecommendationFunnel openByRecommendation={currentState?.open_by_recommendation} />
                    <RiskScoreBreakdown openByRiskScore={currentState?.open_by_risk_score} />
                </div>
                <CoordinatorTable members={members} currentState={currentState} dailyDocs={dailyDocs} />
                <VolumeTrendChart dailyDocs={dailyDocs} />
                <div className="dashboard-two-col">
                    <PayerMix dailyDocs={dailyDocs} />
                    <SourceMix dailyDocs={dailyDocs} />
                </div>
                <FacilityClosedOutcomeBreakdown
                    closedByTerminalOutcome={currentState?.closed_by_terminal_outcome}
                />
                <SeverityBreakdown dailyDocs={dailyDocs} />
                <FlagFiringRate dailyDocs={dailyDocs} />
            </div>
        </RoleGuard>
    );
}
